import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import {
  loadMembershipListAction,
  loadMembershipImgAction,
} from "redux/reducers/membership";

import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import MembershipCard from "components/membership";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  membership: {
    "& .membership-list": {
      padding: `${rem(40)} ${rem(20)} ${rem(60)}`,
      "& .list-tit": {
        fontSize: rem(18),
        fontWeight: 800,
        paddingLeft: rem(10),
        padding: `0 0 ${rem(5)} ${rem(10)}`,
        "& span": {
          paddingLeft: rem(4),
          color: "#F1270B",
        },
      },
      "& .list-tit-sub": {
        color: "#8E8E8E",
        fontSize: rem(14),
        paddingLeft: rem(10),
      },
      "& .list-item-on": {
        height: rem(160),
        backgroundColor: theme.palette.common.white,
        borderRadius: rem(10),
        border: `1px solid #EEEEEE`,
        marginTop: rem(20),
        "& .contents": {
          display: "flex",
          position: "relative",
          height: rem(110),
          alignItems: "center",
          borderBottom: `1px solid #EEEEEE`,
          padding: `${rem(34)} ${rem(30)} ${rem(24)}`,
          "& .image": {
            width: "25%",
          },
          "& .tit-wrap": {
            display: "flex",
            flexDirection: "column",
            width: "65%",
            fontWeight: 800,
            "& span": {
              fontWeight: 400,
              fontSize: rem(14),
            },
            "& .tit": {
              display: "flex",
              alignItems: "center",
              marginBottom: rem(2),
              "& .MuiChip-root": {
                height: rem(15),
                lineHeight: rem(15),
                margin: `0 0 ${rem(2)} ${rem(4)}`,
                padding: `${rem(1)} ${rem(5)} 0`,

                "& .MuiChip-label": {
                  fontSize: rem(10),
                  lineHeight: 1,
                  fontWeight: 800,
                  letterSpacing: "-0.2px",
                },
              },
            },
          },
          "& .func": {
            position: "absolute",
            right: rem(20),
            top: rem(35),
            "& .MuiChip-root": {
              width: rem(53),
              height: rem(30),
              lineHeight: rem(30),
              padding: 0,
              "& .MuiChip-label": {
                fontSize: rem(14),
                fontWeight: 700,
              },
            },
          },
        },
        "& .date-wrap": {
          display: "flex",
          justifyContent: "space-between",
          height: rem(50),
          fontSize: rem(13),
          fontWeight: 700,
          color: "#8E8E8E",
          padding: `${rem(16)} ${rem(30)}`,
          "& span": {
            fontWeight: 400,
            marginLeft: rem(5),
          },
        },
      },

      "& .list-item-off": {
        height: rem(170),
        backgroundColor: theme.palette.common.white,
        borderRadius: rem(10),
        border: `1px solid #EEEEEE`,
        marginTop: rem(15),
        color: "#8E8E8E",
        "& .contents": {
          display: "flex",
          position: "relative",
          height: rem(110),
          alignItems: "center",
          borderBottom: `1px solid #EEEEEE`,
          padding: `${rem(34)} ${rem(30)} ${rem(24)}`,
          "& .image": {
            width: "25%",
            "& img": {
              filter: "grayscale(1)",
            },
          },
          "& .tit-wrap": {
            display: "flex",
            flexDirection: "column",
            width: "65%",
            fontWeight: 800,
            "& span": {
              fontWeight: 400,
              fontSize: rem(14),
            },
            "& .tit": {
              display: "flex",
              alignItems: "center",
              marginBottom: rem(2),
              "& .MuiChip-root": {
                height: rem(15),
                lineHeight: rem(15),
                margin: `0 0 ${rem(2)} ${rem(4)}`,
                padding: `${rem(1)} ${rem(5)} 0`,
                backgroundColor: "#CCCCCC",

                "& .MuiChip-label": {
                  fontSize: rem(10),
                  lineHeight: 1,
                  fontWeight: 800,
                },
              },
            },
          },
          "& .func": {
            position: "absolute",
            right: rem(20),
            top: rem(35),
            "& .MuiChip-root": {
              backgroundColor: "#CCCCCC",
              width: rem(53),
              height: rem(30),
              lineHeight: rem(30),
              padding: 0,
              "& .MuiChip-label": {
                fontSize: rem(14),
                fontWeight: 700,
              },
            },
          },
        },
        "& .date-wrap": {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          height: rem(60),
          fontSize: rem(18),
          fontWeight: 800,
          color: "#F1270B",
          letterSpacing: "-1px",
          padding: `${rem(19)} ${rem(30)}`,
          marginLeft: rem(-4),
          "& span": {
            fontWeight: 400,
          },
          "& .dday": {
            fontSize: rem(13),
          },
        },
      },
      "& .MuiSkeleton-rectangular": {
        borderRadius: rem(10),
        marginTop: rem(15),
      },
    },
    "& .nodata": {
      padding: `${rem(200)} 0`,
    },
  },
}));

export default function Membership() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const { membershipList, loading, membershipImg } = useSelector(
    (state) => state.membership
  );

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const [membershipClubList, setMembershipClubList] = useState([]);
  const [membershipClubJoinList, setMembershipClubJoinList] = useState([]);

  useEffect(() => {
    dispatch(loadMembershipImgAction());
    dispatch(
      loadMembershipListAction({
        storeCode: storeCode || "ALL",
      })
    );
  }, []);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init) dispatch(loadAction({ back: true, title: "클럽", menu: true }));
  }, [init]);

  useEffect(() => {
    if (membershipList) {
      setMembershipClubList(membershipList.membershipClubList);
      setMembershipClubJoinList(membershipList.membershipClubJoinList);
    }
  }, [membershipList]);

  window.appBackKeyHandle = () => {
    history.goBack();
  };

  const handleRefresh = () => {
    return new Promise((resolve) => {
      dispatch(
        loadMembershipListAction({
          storeCode: storeCode || "ALL",
        })
      );
      resolve(membershipList);
    });
  };

  return (
    <>
      <Loading open={loading ? true : false} />
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={classes.membership}>
          {membershipList && (
            <>
              {membershipClubList &&
              membershipClubList.length == 0 &&
              membershipClubJoinList.length == 0 ? (
                <div className="nodata">
                  <Box className="illust">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/icon/nodata.svg`}
                    />
                  </Box>
                  <p className="color-info">진행중인 클럽이 없습니다</p>
                </div>
              ) : (
                <>
                  <div style={{ width: "100%", height: "211px" }}>
                    <LazyCDNImage
                      cdnUrl={membershipImg}
                      style={{
                        width: "100%",
                        height: "211px",
                        objectFit: "cover",
                      }}
                    />
                  </div>
                  <div className="bg-grey membership-list">
                    <div className="list-tit">
                      이용 중인 멤버십
                      <span>{membershipClubJoinList.length}</span>
                    </div>

                    {membershipClubJoinList.length == 0 ? (
                      <div
                        className="nodata"
                        style={{ padding: "80px 0 52px" }}
                      >
                        <Box className="illust">
                          <img
                            src={`${
                              process.env.PUBLIC_URL
                            }/images/icon/nodata.svg`}
                          />
                        </Box>
                        <p className="color-info">가입한 클럽이 없습니다</p>
                      </div>
                    ) : (
                      <MembershipCard
                        list={membershipClubJoinList}
                        tp={"join"}
                      />
                    )}
                  </div>
                  <div className="membership-list">
                    <div className="list-tit">
                      가입 가능한 멤버십<span>{membershipClubList.length}</span>
                    </div>
                    <div className="list-tit-sub">무료로 가입해보세요!</div>
                    <MembershipCard list={membershipClubList} tp={"club"} />
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </PullToRefresh>
    </>
  );
}
